module.exports = __webpack_public_path__ + "static/media/D2AMD.d58a9733.jpg";